import { fetchProducts } from './productDataExcel';
import { processSearchTerms } from './textProcessingService';
import { normalizeText } from '../utils/stringUtils';

export async function searchProducts(query) {
  if (!query.trim()) return [];

  const normalizedQuery = normalizeText(query);
  const products = await fetchProducts();

  // 1) busca direta pelo nome
  const directMatches = products.filter(p =>
    normalizeText(p.name).includes(normalizedQuery)
  );
  if (directMatches.length) {
    return directMatches;
  }

  // 1.5) busca exata na coluna "Aplicaciones"
  const exactMatches = products.filter(p =>
    normalizeText(p.fullApplications) === normalizedQuery
  );
  if (exactMatches.length) {
    return exactMatches;
  }

  // 2) algoritmo de pontuação original
  const searchTerms = processSearchTerms(query);
  if (searchTerms.length === 0) return [];

  const results = products.map(product => {
    let score = 0;
    let matchCount = 0;

    // normalização dos campos
    const normalizedFields = {
      name: normalizeText(product.name),
      applications: normalizeText(product.applications),
      fullApplications: normalizeText(product.fullApplications), // <-- novo
      description: normalizeText(product.description),
      characteristics: normalizeText(product.characteristics),
      benefits: normalizeText(product.benefits),
      sector: normalizeText(product.sector),
      subsector: normalizeText(product.subsector),
      inci: normalizeText(product.inci)
    };

    const fieldWeights = {
      fullApplications: 30, // <-- mais peso para a coluna H
      applications: 20,      // <-- pode ajustar se quiser menos peso
      description: 20,
      characteristics: 15,
      benefits: 15,
      name: 10,
      sector: 5,
      subsector: 5,
      inci: 3
    };

    Object.entries(normalizedFields).forEach(([field, content]) => {
      if (!content) return;
      const weight = fieldWeights[field];
      searchTerms.forEach(term => {
        if (content.includes(term)) {
          score += weight * 2;
          matchCount++;
        }
        if (term.length > 3) {
          content.split(/\s+/).forEach(word => {
            if (
              word.length > 3 &&
              (word.includes(term) || term.includes(word))
            ) {
              score += weight;
              matchCount++;
            }
          });
        }
      });
    });

    const fieldsWithMatches = Object.entries(normalizedFields)
      .filter(([_, content]) =>
        searchTerms.some(term => content.includes(term))
      ).length;

    if (fieldsWithMatches > 1) {
      score *= 1 + fieldsWithMatches * 0.15;
    }

    return { product, score, matchCount };
  });

  const validResults = results
    .filter(r => r.score > 0)
    .sort((a, b) =>
      b.score !== a.score ? b.score - a.score : b.matchCount - a.matchCount
    );

  if (validResults.length === 0) return [];
  if (validResults.length <= 5) {
    return validResults.map(r => r.product);
  }

  const maxScore = validResults[0].score;
  const threshold = maxScore * 0.3;

  // const topResults = validResults
  //   .filter(r => r.score >= threshold)
  //   .slice(0, 5)
  //   .map(r => r.product);

  // return topResults.length >= 2
  //   ? topResults
  //   : validResults.slice(0, 2).map(r => r.product);

  const topResults = validResults
    .filter(r => r.score >= threshold)
    .map(r => r.product);

  return topResults.length > 0
    ? topResults
    : validResults.slice(0, 2).map(r => r.product);

}
